const ForgotPassword = {
  "options": {
    "data": {
      "text": {
        "type": "Text",
        "order": 1
      },
      "description": {
        "type": "Text",
        "order": 1
      }
    },
    "customization": {
      "textColor": {
        "type": "HexColor",
        "order": 2
      },
      "textSize": {
        "type": "RangePx",
        "data": {
          "max": 30,
          "min": 0,
          "step": 1
        },
        "order": 2
      },
      "textWeight": {
        "type": "SelectBox",
        "data": {
          "selectOptions": ["100", "200", "300", "400", "500", "600", "700", "800", "900"]
        },
        "order": 3
      },
      "textPadding": {
        "type": "FourPx",
        "data": {
          "max": 200,
          "min": 0,
          "step": 1,
          "svgType": "edge"
        },
        "order": 4
      },
      "inputTextColor": {
        "type": "HexColor",
        "order": 6
      },
      "inputBackgroundColor": {
        "type": "HexColor",
        "order": 7
      },
      "emailIcon": {
        "type": "IconSelector",
        "data": {
          "defaultIcon": "https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504660_a167aca9-0425-4762-965e-0d6f8c6d24ef.png"
        },
        "order": 8
      },
      "textAlignment": {
        "type": "LeftCenterRight",
        "order": 4
      },
      "buttonColor": {
        "type": "HexColor",
        "order": 7
      },
      "buttonTextColor": {
        "type": "HexColor",
        "order": 7
      }
    }
  },
  "variants": [
    {
      "id": "ForgotPassword_1",
      "name": "ForgotPassword_1",
      "type": "ForgotPassword",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textColor": "#000000",
        "textSize": "20px",
        "textPadding": "10px 10px 10px 10px",
        "textWeight": "700",
        "emailIcon": "https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png",
        "buttonColor": "#6F59EF",
        "buttonTextColor": "#FFFFFF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/forgotpassword.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "ForgotPassword_2",
      "name": "ForgotPassword_2",
      "type": "ForgotPassword",
      "data": {
        "text": "",
        "description": "",
        "images": []
      },
      "customization": {
        "textColor": "#000000",
        "textSize": "20px",
        "textWeight": "700",
        "emailIcon": "https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png",
        "textAlignment": "center",
        "buttonColor": "#6F59EF",
        "buttonTextColor": "#FFFFFF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/forgot_2.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "ForgotPassword_3",
      "name": "ForgotPassword_3",
      "type": "ForgotPassword",
      "data": {
        "text": "",
        "description": "",
        "images": []
      },
      "customization": {
        "textColor": "#000000",
        "textSize": "20px",
        "textWeight": "700",
        "emailIcon": "https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png",
        "textAlignment": "left",
        "buttonColor": "#6F59EF",
        "buttonTextColor": "#FFFFFF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/forgot_3.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "ForgotPassword_4",
      "name": "ForgotPassword_4",
      "type": "ForgotPassword",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "textLetterSpacing": "4px",
        "buttonColor": "#6F59EF",
        "buttonTextColor": "#FFFFFF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/forgot_4.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    },
    {
      "id": "ForgotPassword_5",
      "name": "ForgotPassword_5",
      "type": "ForgotPassword",
      "data": {
        "text": "",
        "description": "",
        "images": []
      },
      "customization": {
        "textColor": "#000000",
        "textSize": "20px",
        "textWeight": "700",
        "emailIcon": "https://d9aff4nz0lkg0.cloudfront.net/seyf/mail.png",
        "textAlignment": "left",
        "buttonColor": "#6F59EF",
        "buttonTextColor": "#FFFFFF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/forgot_5.png",
      "minMobileAppVersion": 1,
      "isComingSoon": false
    },
    {
      "id": "ForgotPassword_6",
      "name": "ForgotPassword_6",
      "type": "ForgotPassword",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "textLetterSpacing": "4px",
        "buttonColor": "#6F59EF",
        "buttonTextColor": "#FFFFFF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/forgot_6.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    },
    {
      "id": "ForgotPassword_7",
      "name": "ForgotPassword_7",
      "type": "ForgotPassword",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "textLetterSpacing": "4px",
        "buttonColor": "#6F59EF",
        "buttonTextColor": "#FFFFFF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/forgot_7.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    },
    {
      "id": "ForgotPassword_8",
      "name": "ForgotPassword_8",
      "type": "ForgotPassword",
      "data": {
        "text": "",
        "images": []
      },
      "customization": {
        "textAlignment": "left",
        "textSize": "12px",
        "textColor": "#7059ef",
        "textStyle": "normal",
        "textWeight": "400",
        "textLetterSpacing": "4px",
        "buttonColor": "#6F59EF",
        "buttonTextColor": "#FFFFFF"
      },
      "variantData": {
        "isEditable": true,
        "aspectRatio": "1/1",
        "minImage": 4,
        "maxImage": 12,
        "modulo": 1,
        "renderTabs": {
          "product": null
        }
      },
      "placeholderImage": "https://d9aff4nz0lkg0.cloudfront.net/forgot_8.png",
      "minMobileAppVersion": 1,
      "isComingSoon": true
    }
  ]
}

 export default ForgotPassword